<template>
  <label class="block my-2">
    {{ codeLabel }}
  </label>
  <div class="code-wrapper">
    <button
      v-if="showCopyButton"
      class="copy-btn"
      @click="copyToClipboard"
    >
      <i
        v-if="!isCopied"
        class="far fa-copy"
      /> {{ isCopied ? t('copied') : t('copy') }}
    </button>
    <pre class="code-block">{{ code }}</pre>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRef, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'CodeBlock',

  props: {
    // eslint-disable-next-line vue/no-unused-properties
    label: {
      type: String,
      required: false,
      default: null,
    },

    // eslint-disable-next-line vue/no-unused-properties
    content: {
      type: String,
      required: true,
    },

    showCopyButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const codeLabel = toRef(props, 'label');
    const code = toRef(props, 'content');
    const isCopied = ref(false);

    const copyToClipboard = () => {
      const rawContent = code.value;

      const contentToCopy = typeof rawContent === 'object'
        ? JSON.stringify(rawContent, null, 2)
        : String(rawContent);

      navigator.clipboard.writeText(contentToCopy)
        .then(() => {
          isCopied.value = true;
          setTimeout(() => {
            isCopied.value = false;
          }, 1000);
        })
        .catch(() => {
          // silencieux
        });
    };

    return {
      t,
      codeLabel,
      code,
      copyToClipboard,
      isCopied,
    };
  },
});
</script>

<style scoped>
.code-wrapper {
  position: relative;
}

.code-block {
  background-color: #f0f1f2;
  color: #292a2e;
  padding: 10px 5px 10px 5px;
  overflow-x: auto;
  font-family: monospace;
  font-size: 0.8rem;
  text-align: left;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 32px;

  &.with-copy {
    padding: 10px 70px 10px 5px;
  }
}

.copy-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #e0e0e0;
  border: none;
  font-size: 0.7rem;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.copy-btn:hover {
  background-color: #d5d5d5;
}
</style>
